import { Button, Modal } from "antd";

const DeleteTeam = ({ isOpen, handleCancel, handleDelete, isLoading }) => {
  return (
    <Modal
      title={
        <div
          className="heading24px text-color-1C1C1C roboto-medium"
          style={{ padding: "20px 24px 10px" }}
        >
          Delete Team
        </div>
      }
      className="delete-popup"
      open={isOpen}
      centered
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
    >
      <div style={{ padding: "20px 24px 10px" }}>
        Are you sure you want to delete {isOpen?.teamName}? This action cannot
        be undone.
        <div
          className="mt20 d-flex justify-content-end align-items-center mb10"
          style={{ gap: 20 }}
        >
          <Button className="light-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            disabled={isLoading}
            className="stop-sync"
            onClick={() => {
              handleDelete(isOpen);
              handleCancel();
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTeam;
